import { connect } from 'react-redux';

import {
  fetchSelfAuthorizations,
  fetchUniqueSelectors,
  getCurrentSelection,
  getSelectorsData,
  setActiveSelfAuthTab,
  setDataList,
  setSelfAuthorizations,
  setSelfAuthorizationsPending,
} from '../store/selfAuthorizationsSlice';
import { setAuthorizationBy } from '../store/createNewSelfAuthorizationSlice';
import { resetCardFilters, setFilters } from '../../filters/store/filtersSlice';
import { setMobileDrawerOpen } from '../../mobile-drawer/store/mobileDrawerSlice';

import Sidebar from './Sidebar';

const mapStateToProps = state => ({
  currentSelection: getCurrentSelection(state),
  dataListPending: state.loadingManagement.selfAuthorizations.dataListPending,
  selectedIndex: state.loadingManagement.filters.selectedIndex,
  selectorsData: getSelectorsData(state),
  selfAuthorizationsPending: state.loadingManagement.selfAuthorizations.selfAuthorizationsPending,
});

const mapDispatchToProps = {
  fetchSelfAuthorizations,
  fetchUniqueSelectors,
  resetCardFilters,
  setActiveSelfAuthTab,
  setAuthorizationBy,
  setDataList,
  setFilters,
  setMobileDrawerOpen,
  setSelfAuthorizations,
  setSelfAuthorizationsPending,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
